/**
 * @desc 查询入库单箱号
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.getInMasterFillBox.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/getInMasterFillBox`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
